var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i-col',{staticClass:"card-column",attrs:{"xl":3,"md":4,"sm":6,"xs":24}},[_c('Card',{staticClass:"partner-item-card",attrs:{"dis-hover":""}},[_c('a',{attrs:{"href":_vm.trim(_vm.link),"rel":"noopener noreferrer","target":"_blank"}},[_c('h3',[_vm._v(_vm._s(_vm.name))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }